import type { Component } from "solid-js";
import { useCustomContext } from "~/solidJs/shared";
import { PricingPageParams } from "~/solidJs/shared/models/pageParams";
import { SegmentGroup } from "~/solidJs/shared/ui/molecules/SegmentGroup";
import { PricingPageContext } from "../methods";

export const SwitchSubscriptionType: Component = () => {
	const store = useCustomContext(PricingPageContext);

	const segmentItems: SegmentGroup.ClosedSegmentGroupItem[] = [
		{
			value: PricingPageParams.SubscriptionType.Personal,
			label: "Personal"
		},
		{
			value: PricingPageParams.SubscriptionType.Enterprise,
			label: "Enterprise"
		}
	];

	return (
		<SegmentGroup.SegmentGroupClosedComponent
			value={store.getSubscriptionType()}
			rootProps={{
				onValueChange(v) {
					store.setSubscriptionType(v.value as PricingPageParams.SubscriptionType);
				}
			}}
			items={segmentItems}
		/>
	);
};
